import { z } from 'zod';
/**
 * Discriminator for the FeatureValue / FeatureValidation / FeatureDef union.
 * Numeric values match the feature_types table (typeId column on Features).
 */
export var FeatureType;
(function (FeatureType) {
    FeatureType[FeatureType["Boolean"] = 1] = "Boolean";
    FeatureType[FeatureType["String"] = 2] = "String";
    FeatureType[FeatureType["Number"] = 3] = "Number";
    FeatureType[FeatureType["Markdown"] = 4] = "Markdown";
    FeatureType[FeatureType["MultiSelect"] = 5] = "MultiSelect";
    FeatureType[FeatureType["Json"] = 6] = "Json";
})(FeatureType || (FeatureType = {}));
/**
 * FeatureArea is the canonical scope_type identifier.
 *
 * When the per-scope junction tables (ApplicationFeatures, BrandFeatures,
 * AgentFeatures, GroupFeatures, ModuleFeature) collapse into a single
 * feature_overrides table, this enum becomes the scope_type column's value
 * set verbatim. Do NOT introduce a parallel ScopeType type - extend this
 * enum instead.
 *
 * 'group' and 'module' are present here ahead of any feature declaring them
 * so the unified-table refactor doesn't require an enum migration.
 */
export const FeatureAreaSchema = z.enum([
    'agent',
    'application',
    'brand',
    'account',
    'group',
    'module',
    'data-connection',
]);
